<template>
  <div class="wrapper">
    <div class="icon-wrapper">
      <IconPerson
        v-if="icon === 'settings' && role === 'CLIENT'"
        :color="color"
      />
      <IconPerson v-if="icon === 'clients'" />
      <IconPerson v-if="icon === 'employees'" />
      <IconSettings
        v-if="icon === 'account' && role !== 'CLIENT'"
        :color="color"
      />
      <IconReview v-if="icon === 'reviews'" />
      <IconFav v-if="icon === 'favorites'" />
      <IconBooking v-if="icon === 'bookings'" />
      <IconBooking v-if="icon === 'business-booking'" />
      <IconHouse v-if="icon === 'administrators'" />
      <IconHouse v-if="icon === 'catering'" />
      <IconStatistics v-if="icon === 'statistics'" />
      <IconSettings
        v-if="icon === 'settings' && role !== 'CLIENT'"
        :color="color"
      />
      <IconDocuments v-if="icon === 'documents'" />
      <IconDocuments v-if="icon === 'counterparties'" />
      <IconTariffs v-if="icon === 'tariffs'" />
      <IconPackages v-if="icon === 'packages'" />
      <IconTariffs v-if="icon === 'payments'" />
      <IconWidgetNav v-if="icon === 'widgets'" />
      <MapIcon v-if="icon === 'map'" />
    </div>
    <span class="item-text">
      <slot />
    </span>
  </div>
</template>

<script>
import IconBooking from "@/components/icons/IconBooking";
import IconFav from "@/components/icons/IconFav";
import IconReview from "@/components/icons/IconReview";
import IconPerson from "@/components/icons/IconPerson";
import IconHouse from "@/components/icons/IconHouse";
import IconStatistics from "@/components/icons/IconStatistics";
import IconSettings from "@/components/icons/IconSettings";
import IconDocuments from "@/components/icons/IconDocuments";
import IconTariffs from "@/components/icons/IconTariffs.vue";
import IconPackages from "@/components/icons/IconTariffs.vue";
import IconWidgetNav from "@/components/icons/IconWidgetNav.vue";
import MapIcon from "@/components/icons/MapIcon.vue";

export default {
  name: "MobileNavButton",
  components: {
    MapIcon,
    IconWidgetNav,
    IconPackages,
    IconTariffs,
    IconSettings,
    IconStatistics,
    IconHouse,
    IconPerson,
    IconReview,
    IconFav,
    IconBooking,
    IconDocuments,
  },
  data() {
    return {
      currentPath: "default",
    };
  },
  computed: {
    role() {
      return this.$store.getters.role;
    },
  },
  props: {
    icon: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (!this.path) {
      this.currentPath = this.icon;
    } else {
      this.currentPath = this.path;
    }
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #222222;
}

.icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 16px;
  background: #fef6e8;
}

.item-text {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
</style>
